import { navigate } from 'gatsby'
import { defaultLang } from '../../constants'

const defaultToDe = (value, language) =>
  // eslint-disable-next-line no-nested-ternary
  value ? (value[language] ? value[language] : value[defaultLang]) : ''

export const url = (locale: 'de' | 'en' | 'fr') => (to: string) =>
  `/${locale === defaultLang ? `` : `${locale}/`}${to}`

export const makeNavigate = (locale: 'de' | 'en' | 'fr') => (to: string) =>
  navigate(url(locale)(to))

export const translate = (language) => (value) => defaultToDe(value, language)
export default defaultToDe
